export default __webpack_public_path__ + "static/media/logo2.0e4cfc68.PNG";